(function () {
  'use strict';
  function mount(header) {
    if (header.dataset.megaMenuReady) return;
    header.dataset.megaMenuReady = 'true';
    var menus = Array.from(header.querySelectorAll('[data-mega-menu]'));
    var controller = new AbortController();
    var observers = [];
    var pointerType = 'mouse';
    var hoverCloseTimer;
    var transparent = false;
    try { transparent = JSON.parse(header.dataset.sectionSettings || '{}').hasTransparentHeader === true; } catch (error) {}
    var options = { capture: true, signal: controller.signal };
    function itemFor(target) {
      return menus.find(function (menu) { return menu.parentElement.contains(target); });
    }
    function sync(menu) {
      var open = menu.getAttribute('aria-hidden') === 'false';
      if (!open && menu.contains(document.activeElement)) {
        menu.parentElement.querySelector('[data-mega-menu-trigger]').focus({ preventScroll: true });
      }
      menu.inert = !open;
      if (transparent) {
        var anyOpen = header.querySelector('.Header__MainNav [aria-hidden="false"]');
        header.classList.toggle('Header--transparent', !anyOpen && window.pageYOffset <= 10);
      }
      menu.parentElement.querySelectorAll('[data-mega-menu-trigger], [data-mega-menu-toggle]').forEach(function (control) {
        control.setAttribute('aria-expanded', String(open));
      });
    }
    function cancelHoverClose() {
      window.clearTimeout(hoverCloseTimer);
      hoverCloseTimer = undefined;
    }
    function inHoverGap(menu, event) {
      var itemRect = menu.parentElement.getBoundingClientRect();
      var menuRect = menu.getBoundingClientRect();
      return menuRect.top > itemRect.bottom &&
        event.clientX >= menuRect.left && event.clientX <= menuRect.right &&
        event.clientY >= itemRect.bottom && event.clientY <= menuRect.top;
    }
    function updateHoverClose(menu, event) {
      var target = event.type === 'mouseleave' ? event.relatedTarget : event.target;
      if (menu.parentElement.contains(target) || inHoverGap(menu, event)) {
        cancelHoverClose();
      } else if (hoverCloseTimer === undefined) {
        hoverCloseTimer = window.setTimeout(function () {
          hoverCloseTimer = undefined;
          if (!menu.parentElement.contains(document.activeElement)) setOpen(menu, false);
        }, 200);
      }
    }
    function setOpen(menu, open) {
      cancelHoverClose();
      if (open) menus.forEach(function (other) { if (other !== menu) setOpen(other, false); });
      menu.parentElement.classList.toggle('is-expanded', open);
      menu.setAttribute('aria-hidden', String(!open));
      sync(menu);
    }
    menus.forEach(function (menu) {
      sync(menu);
      var observer = new MutationObserver(function () { sync(menu); });
      observer.observe(menu, { attributes: true, attributeFilter: ['aria-hidden'] });
      observers.push(observer);
    });
    document.addEventListener('pointerover', function (event) {
      pointerType = event.pointerType || 'mouse';
    }, { signal: controller.signal });
    // Own hover for these items so synthetic touch hover cannot race a disclosure click.
    document.addEventListener('mouseenter', function (event) {
      var menu = itemFor(event.target);
      if (!menu) return;
      event.stopPropagation();
      if (event.target === menu.parentElement && pointerType !== 'touch' && window.matchMedia('(hover: hover) and (pointer: fine)').matches) setOpen(menu, true);
    }, options);
    document.addEventListener('mouseleave', function (event) {
      var focusedMenu = itemFor(document.activeElement);
      var openMenu = menus.find(function (menu) { return menu.getAttribute('aria-hidden') === 'false'; });
      if (event.target === header && (focusedMenu || openMenu)) {
        event.stopPropagation();
        if (!focusedMenu) updateHoverClose(openMenu, event);
        return;
      }
      var menu = itemFor(event.target);
      if (!menu || event.target !== menu.parentElement) return;
      event.stopPropagation();
      updateHoverClose(menu, event);
    }, options);
    document.addEventListener('pointermove', function (event) {
      pointerType = event.pointerType || pointerType;
      if (pointerType === 'touch' || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
      var menu = menus.find(function (item) { return item.getAttribute('aria-hidden') === 'false'; });
      if (menu) updateHoverClose(menu, event);
    }, { signal: controller.signal });
    // Capture focus before Prestige's delegated focus handlers. Only this menu is owned here.
    document.addEventListener('focusin', function (event) {
      if (!header.isConnected) return;
      var menu = itemFor(event.target);
      if (menu) event.stopPropagation();
      else menus.forEach(function (other) { setOpen(other, false); });
    }, options);
    document.addEventListener('focusout', function (event) {
      if (!header.isConnected) return;
      var menu = itemFor(event.target);
      if (!menu) return;
      event.stopPropagation();
      if (!event.relatedTarget || !menu.parentElement.contains(event.relatedTarget)) setOpen(menu, false);
    }, options);
    header.addEventListener('click', function (event) {
      var toggle = event.target.closest('[data-mega-menu-toggle]');
      if (!toggle) return;
      var menu = itemFor(toggle);
      if (!menu) return;
      event.preventDefault();
      event.stopPropagation();
      setOpen(menu, menu.getAttribute('aria-hidden') !== 'false');
    }, options);
    header.addEventListener('keydown', function (event) {
      var menu = itemFor(event.target);
      if (!menu) return;
      var onControl = event.target.matches('[data-mega-menu-trigger], [data-mega-menu-toggle]');
      if (event.key === 'Escape' && menu.getAttribute('aria-hidden') === 'false') {
        event.preventDefault();
        event.stopPropagation();
        menu.parentElement.querySelector('[data-mega-menu-trigger]').focus({ preventScroll: true });
        setOpen(menu, false);
      } else if (onControl && (event.key === 'ArrowDown' || event.key === 'ArrowUp')) {
        event.preventDefault();
        setOpen(menu, true);
        var links = Array.from(menu.querySelectorAll('a[href]'));
        var link = event.key === 'ArrowUp' ? links[links.length - 1] : links[0];
        if (link) link.focus({ preventScroll: true });
      }
    }, { signal: controller.signal });
    document.addEventListener('pointerdown', function (event) {
      if (!header.isConnected || itemFor(event.target)) return;
      menus.forEach(function (menu) { setOpen(menu, false); });
    }, { signal: controller.signal });
    document.addEventListener('shopify:section:unload', function (event) {
      if (!event.target.contains(header)) return;
      cancelHoverClose();
      controller.abort();
      observers.forEach(function (observer) { observer.disconnect(); });
      delete header.dataset.megaMenuReady;
    }, { signal: controller.signal });
  }
  function boot(root) {
    root.querySelectorAll('.Header').forEach(mount);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); }, { once: true });
  else boot(document);
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
}());
